<template>
  <layout>
    <LandingHero></LandingHero>

    <Carousel class="mt-32 xl:mt-40"></Carousel>

    <div class="max-w-screen-xl pt-32 mx-auto">
      <div class="flex flex-col w-full px-8 lg:flex-row lg:px-32 lg:pt-12">
        <div class="flex justify-end w-full mr-6 lg:w-1/2">
          <Slideshow
            images="/img/car1/hraz.jpg,/img/car3/posezeni.jpg,/img/car3/okenice.jpg,/img/car3/tullamore.jpg"
          ></Slideshow>
        </div>
        <div class="w-full pt-12 lg:pl-6 lg:w-1/2 lg:pt-0">
          <h1 class="text-2xl font-semibold text-ch-900">Úvod</h1>
          <p class="pt-6 font-light leading-loose text-gray-800">
            Areál chaty se nachází v malebném, tichém údolí zhruba 250 metrů od
            hráze Luhačovické přehrady.<br />
            Na své si zde přijdou jak lázenší hosté, tak nadšenci rekreačních
            sportů jako např. cyklistika nebo jízda na&nbsp;kolečkových
            bruslích.<br />
            Ať už si chcete odpočinout nebo strávit báječnou dovolenou s Vaší
            rodinou, Chata pod Luhačovickou přehradou je pro Vás ta správná
            volba.
          </p>
        </div>
      </div>

      <div
        class="flex flex-col-reverse w-full px-8 lg:flex-row lg:px-32 lg:pt-16"
      >
        <div class="w-full pt-6 mr-6 lg:w-1/2 lg:pt-0">
          <h1 class="text-2xl font-semibold text-ch-900">Interiér</h1>
          <p class="pt-6 font-light leading-relaxed text-chsoftblue">
            V prvním patře najdete obytnou místnost s kuchyňkou (plynový vařič,
            rychlovarná konvice, mikrovlnná trouba, lednička s&nbsp;mrazícím
            boxem), krbovými kamny a TV. Možnost využití klimatizace k topení a
            chlazení.
          </p>
          <p class="pt-1 font-light leading-relaxed text-chsoftblue">
            Při vstupu do chaty je zastřešená terasa. Dále se zde nachází
            dvoulůžkový pokoj a WC se&nbsp;sprchou.
          </p>
          <p class="pt-1 font-light leading-relaxed text-chsoftblue">
            V útulném podkroví naleznete čtyřlůžkový pokoj s pracovním stolkem.
          </p>
          <p class="pt-1 font-light leading-relaxed text-chsoftblue">
            V přízemí se nachází společenská místnost a druhá toaleta.
          </p>
        </div>
        <div class="w-full pt-16 lg:w-1/2 lg:flex lg:justify-end lg:pt-0">
          <slideshow
            images="/img/car2/obyvak.jpg,/img/car2/kuchyne.jpg,/img/car2/dvouluzko.jpg"
          ></slideshow>
        </div>
      </div>

      <div class="flex flex-col w-full px-8 lg:flex-row lg:px-32 lg:pt-16">
        <div class="flex justify-end w-full pt-16 lg:w-1/2 lg:pt-0">
          <slideshow
            images="/img/car1/chatacela.jpg,/img/galerie/stolni_tenis.JPG,/img/car2/balkon.jpg"
          ></slideshow>
        </div>
        <div class="w-full pt-6 lg:pl-6 lg:w-1/2 lg:pt-0">
          <h1 class="text-2xl font-semibold text-ch-900">Exteriér</h1>
          <p class="pt-6 font-light leading-relaxed text-chsoftblue">
            Domimantou Chaty je obrovská zahrada s výměrou cca 1 000 m², na
            které najdete branku, houpačku a skluzavku.
          </p>
          <p class="pt-1 font-light leading-relaxed text-chsoftblue">
            Na spodní, zastřešené terase je pro Vás připraven stolní tenis
            a&nbsp;fotbálek. (Pálky na stolní tenis a míčky nejsou k dispozici.)
          </p>
          <p class="pt-1 font-light leading-relaxed text-chsoftblue">
            Dále nabízíme venkovní posezení s grilem, ohništěm a&nbsp;udírnou.
          </p>
        </div>
      </div>
    </div>
    <div class="px-8 py-16 md:px-0">
      <Cenik></Cenik>
    </div>

    <div class="max-w-5xl pt-16 mx-auto md:pt-16">
      <Calendar></Calendar>
    </div>

    <div class="flex justify-center pt-4 pb-16 md:pt-8">
      <Link
        class="px-8 py-2 text-2xl text-white rounded cursor-pointer opacity-90 bg-chred hover:bg-chreddark"
        href="/rezervace"
        >Vytvořit rezervaci</Link
      >
    </div>
  </layout>
</template>

<script>
import layout from "../Layouts/default.vue";
import LandingHero from "../components/landing-hero.vue";
import Cenik from "../components/Cenik.vue";
import Carousel from "../components/Carousel.vue";
import Slideshow from "../components/Slideshow.vue";
import Calendar from "../components/Calendar.vue";
import { Link } from "@inertiajs/inertia-vue3";

export default {
  components: {
    layout,
    LandingHero,
    Cenik,
    Carousel,
    Slideshow,
    Calendar,
    Link,
  },
};
</script>
